// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

class MIURToolPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      numSaving: 0,
      skipped: 0,

      errors: [],

      orderGroups: null,
      nextOrderGroups: null,
      num_remaining: 0,

      nextTimeout: null
    };

    this.MAX_FETCHED = 1;

    this.getOrders = this.getOrders.bind(this);
    this.next = this.next.bind(this);
    this.associateSchool = this.associateSchool.bind(this);
  }

  componentDidMount() {
    this.getOrders('orderGroups');
    this.getOrders('nextOrderGroups');
  }

  getOrders(target, callback) {
    API.call('GET', Settings.V3_API_URL + '/reports/miur/kit-orders?offset=0&limit=' + this.MAX_FETCHED, {}, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState((prevState) => {
          prevState.errors.push({
            fetching: false,

            message: 'cannot get orders: ' + error.message
          });

          return prevState;
        });

        return false;
      }

      if (response.data && response.data.orders) {
        this.setState((prevState) => {
          prevState.fetching = false;

          prevState[target] = response.data.orders;
          prevState.num_remaining = response.total_count - this.MAX_FETCHED;

          return prevState;
        });

        if (callback) {
          callback();
        }
      }
    });
  }

  next() {
    if (this.state.nextOrderGroups) {
      this.setState({
        fetching: false,
        orderGroups: this.state.nextOrderGroups,
        nextOrderGroups: null
      }, () => {
        this.getOrders('nextOrderGroups');
      });
    } else {
      // try in a bit
      window.clearTimeout(this.state.nextTimeout);
      const t = window.setTimeout(this.next, 1000);

      this.setState({
        fetching: true,

        nextTimeout: t
      });
    }
  }

  associateSchool(key, schoolId) {
    const orders = this.state.orderGroups[key];

    console.log('==============================================================');
    console.log('associate schools');
    console.dir(orders);
    console.log('==============================================================');

    this.setState({
      numSaving: orders.length
    });

    orders.forEach((order) => {
      const myOrder = order.original_order;
      myOrder.school_id = schoolId;

      // // set some legacy props to avoid validation errors
      // [
      //   'teacher_id',
      //   'teacher_first_name',
      //   'teacher_last_name',
      //   'teacher_email',
      //   'teacher_city',
      //   'teacher_province',
      //   'teacher_phone',
      //   'teacher_subject',

      //   'school_address',
      //   'school_certified_email',
      //   'school_city',
      //   'school_email',
      //   'school_fax',
      //   'school_google_place_id',
      //   'school_location_id',
      //   'school_manager',
      //   'school_mech_id',
      //   'school_name',
      //   'school_nuts3_2010_code',
      //   'school_phone',
      //   'school_province',
      //   'school_region',
      //   'school_school_type',
      //   'school_zip_code'
      // ].forEach((prop) => {
      //   if (myOrder[prop] === '') {
      //     myOrder[prop] = 'N/D';
      //   }
      // });

      const endpoint = Settings.V3_API_URL + '/kit-orders/' + myOrder.id;

      API.call('PUT', endpoint, myOrder, (response, error) => {
        if (error) {
          console.dir(error);

          this.setState((prevState) => {
            alert('Errore salvataggio: ' + error.message);
            prevState.numSaving--;
            prevState.errors.push({
              message: 'ERRORE salvataggio: ' + error.message
            });

            return prevState;
          });

          return false;
        }

        this.setState((prevState) => {
          prevState.numSaving--;

          return prevState;
        }, () => {
          if (this.state.numSaving == 0) {
            this.next();
          }
        });
      });
    });
  }

  render() {
    const pageOutput = !this.state.orderGroups ? '' : Object.keys(this.state.orderGroups).map((key) => {
      const order = this.state.orderGroups[key][0];
      const numOrders = this.state.orderGroups[key].length;

      return (
        <div className="card" style={{marginTop: '0.5rem', borderTop: '1px solid #ccc', paddingTop: '1rem'}}>
          <div className="card-body">
            <div className="row" style={{marginTop: 0}}>
              <div className="col-6">
                <h4 style={{marginTop: 0, marginBottom: '1rem', color: '#888'}}><i className="fa fa-school" /> SCUOLA</h4>
                <p style={{marginBottom: 0}}>{order.school_school_type}</p>
                <h3>{order.school_name} <small>({numOrders} {numOrders == 1 ? 'richiesta' : 'richieste'})</small></h3>
                <p>
                  {order.school_address}<br />
                  {order.school_zip_code}<br />
                  {order.school_city}<br />
                  prov. {order.school_province}
                </p>
                <p>
                  <a href={'mailto:' + order.school_email}>{order.school_email}</a> -- {order.school_phone}
                </p>

                <h4 style={{marginTop: '2.5rem', marginBottom: '1rem', color: '#888'}}><i className="fa fa-chalkboard-teacher" /> INSEGNANTE</h4>
                <h3>
                {order.original_order.teacher_first_name} {order.original_order.teacher_last_name}</h3>
                <p>
                  <a href={'mailto:' + order.original_order.teacher_email}>{order.original_order.teacher_email}</a> -- {order.original_order.teacher_phone}<br />
                </p>

                <h4 style={{marginTop: '2.5rem', marginBottom: '1rem', color: '#888'}}>
                  <i className="fa fa-gift" /> KIT
                </h4>
                  {
                    order.kits && order.kits.map((kit) => {
                      const kitName = kit.name.length > 50 ? (
                        kit.name.split('/').slice(-1)[0] // crazy names from old kits
                      ) : (
                        kit.name
                      );

                      const y = parseInt(String(kit.schoolyear).split('/')[0]);
                      const schoolyear = y + '/' + String(y+1).substr(2, 2);
                      return (
                        <div>
                          <h3>{kitName}</h3>
                          <p>
                            A/S: {schoolyear}
                          </p>
                        </div>
                      );
                    })
                  }
              </div>
              <div className="col-6">
                <h4 style={{marginTop: '0', marginBottom: '1rem', color: '#888'}}><i className="far fa-check-square" /> ASSEGNA SCUOLA</h4>
                <p>Scuola non presente? Aggiungi codice meccanografico manualmente:</p>
                <div className="row">
                  <div className="col-8"><input id="input_school_id" className="form-control" /></div>
                  <div className="col-4">
                    <button className="btn btn-primary" onClick={() => {
                      if (window.confirm('Sei sicura di voler assegnare a questa scuola?')) {
                        this.associateSchool(key, document.getElementById('input_school_id').value);
                        document.getElementById('input_school_id').value = '';
                      }
                    }
                    }>Assegna</button>
                  </div>
                </div>

                {
                  order.miur_schools && order.miur_schools.map((school) => {
                    return (
                      <table style={{marginTop: '1.5rem', marginBottom: '0.25rem', borderTop: '1px solid #ccc', paddingTop: '0'}}>
                        <tbody>
                          <tr>
                            <td align="center" valign="middle">
                              <a style={{marginRight: '1.5rem'}} className="btn btn-primary" href="javascript:void(0);" onClick={() => {if (window.confirm('Sei sicura di voler assegnare a questa scuola?')) this.associateSchool(key, school.id)}}>Seleziona</a>
                            </td>
                            <td>
                              <p style={{marginTop: '0.5rem', marginBottom: 0}}>{school.type}</p>
                              <h4>{school.name}</h4>
                              <p>
                                {school.address}<br />
                                {school.postcode}<br />
                                {school.city_name}<br />
                                {school.province_name}<br />
                                C.M.: {school.id}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>
      );
    });

    let related;
    if (!this.state.orderGroups) {
      related = [];
    }
    if (this.state.orderGroups && !this.state.nextOrderGroups) {// whatever happens, don't show if main orders not loaded
      related = [
        {
          icon: 'fa fa-spin fa-circle-notch',
          label: 'Successivo...',
          href: '',
          onClick: () => false
        }
      ];
    }
    if (this.state.orderGroups && this.state.nextOrderGroups) {
      related = [
        {
          icon: 'fa fa-step-forward',
          label: 'Successivo',
          href: '',
          onClick: this.next
        }
      ];
    }

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar related={related} />
          <MainHeading
            icon=""
            title="Tool MIUR"
            descr=""
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: 'Richieste',
            descr: `(${this.state.num_remaining} rimanenti)`,
            onExport: null
          }}
          status={{
            fetching: !this.state.orderGroups,
            errors: this.state.errors
          }}
        >
          {
            this.state.errors.length > 0 ? (
              <div>
                <h3>ERRORE</h3>
                <p>
                  {
                    this.state.errors.map((message) => {
                      return <span>message<br /></span>;
                    })
                  }
                </p>
              </div>
              ) : ''
          }
          {
            this.state.numSaving > 0 ? (
              <h3><Spinner message={'Salvataggio di ' + this.state.numSaving + ' ' + (this.state.numSaving == 1 ? 'richiesta' : 'richieste') + ' in corso...'} /></h3>
            ) : ''
          }
          {
            this.state.fetching ? (
              <h3><Spinner message="Ricarico richieste..." /></h3>
            ) : ''
          }
          {pageOutput}
        </PageDataWrapper>
      </div>
    );
  }
}

export default MIURToolPage;


// WEBPACK FOOTER //
// ./src/pages/tools/MIURToolPage.js